import * as React from "react";

function Customers(props) {
  return (
    <svg width={18} height={21} fill="none" {...props}>
      <path
        d="M17 19.014v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        clipRule="evenodd"
        d="M9 9.014a4 4 0 100-8 4 4 0 000 8z"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

const CustomersIcon = React.memo(Customers);
export default CustomersIcon;
